var map = {
	"./AED.svg": 3078,
	"./AUD.svg": 5379,
	"./AZN.svg": 1583,
	"./CAD.svg": 3250,
	"./CHF.svg": 8339,
	"./CNY.svg": 1565,
	"./DKK.svg": 8900,
	"./EUR.svg": 1123,
	"./GBP.svg": 7793,
	"./IQD.svg": 619,
	"./JPY.svg": 6643,
	"./MYR.svg": 5834,
	"./NOK.svg": 3874,
	"./OMR.svg": 6079,
	"./SEK.svg": 4254,
	"./TRY.svg": 9536,
	"./USD.svg": 7619,
	"./ac.svg": 7787,
	"./ad.svg": 5271,
	"./af.svg": 4041,
	"./ag.svg": 4890,
	"./ai.svg": 965,
	"./al.svg": 9790,
	"./am.svg": 6101,
	"./ao.svg": 6831,
	"./aq.svg": 4562,
	"./ar.svg": 8748,
	"./as.svg": 2955,
	"./at.svg": 6044,
	"./aw.svg": 6001,
	"./ax.svg": 9405,
	"./ba.svg": 6387,
	"./bb.svg": 4883,
	"./bd.svg": 5344,
	"./be.svg": 6115,
	"./bf.svg": 7849,
	"./bg.svg": 6873,
	"./bh.svg": 1026,
	"./bi.svg": 3430,
	"./bj.svg": 4555,
	"./bl.svg": 1127,
	"./bm.svg": 855,
	"./bn.svg": 8717,
	"./bo.svg": 9045,
	"./bq.svg": 3086,
	"./br.svg": 5214,
	"./bs.svg": 3990,
	"./bt.svg": 4122,
	"./bv.svg": 8709,
	"./bw.svg": 4742,
	"./by.svg": 92,
	"./bz.svg": 8704,
	"./cc.svg": 9202,
	"./cd.svg": 1381,
	"./cefta.svg": 9071,
	"./cf.svg": 6199,
	"./cg.svg": 8033,
	"./ci.svg": 9420,
	"./ck.svg": 4252,
	"./cl.svg": 7233,
	"./cm.svg": 2659,
	"./co.svg": 5179,
	"./cp.svg": 9234,
	"./cr.svg": 8013,
	"./cu.svg": 9778,
	"./cv.svg": 6152,
	"./cw.svg": 5455,
	"./cx.svg": 2108,
	"./cy.svg": 128,
	"./cz.svg": 2597,
	"./de.svg": 1571,
	"./dg.svg": 6265,
	"./dj.svg": 9388,
	"./dm.svg": 3067,
	"./do.svg": 1867,
	"./dz.svg": 6283,
	"./ea.svg": 6824,
	"./ec.svg": 9853,
	"./ee.svg": 1882,
	"./eg.svg": 3479,
	"./eh.svg": 4912,
	"./er.svg": 8713,
	"./es-ct.svg": 6804,
	"./es-ga.svg": 9741,
	"./es-pv.svg": 6625,
	"./es.svg": 771,
	"./et.svg": 4116,
	"./fi.svg": 1778,
	"./fj.svg": 1493,
	"./fk.svg": 1658,
	"./fm.svg": 5861,
	"./fo.svg": 8986,
	"./fr.svg": 8388,
	"./ga.svg": 1785,
	"./gb-eng.svg": 9618,
	"./gb-nir.svg": 2107,
	"./gb-sct.svg": 1269,
	"./gb-wls.svg": 1777,
	"./gd.svg": 3350,
	"./ge.svg": 5408,
	"./gf.svg": 9568,
	"./gg.svg": 5203,
	"./gh.svg": 9259,
	"./gi.svg": 1423,
	"./gl.svg": 1118,
	"./gm.svg": 7288,
	"./gn.svg": 7224,
	"./gp.svg": 4273,
	"./gq.svg": 5237,
	"./gr.svg": 123,
	"./gs.svg": 7721,
	"./gt.svg": 2457,
	"./gu.svg": 5545,
	"./gw.svg": 6646,
	"./gy.svg": 8562,
	"./hk.svg": 6148,
	"./hm.svg": 6317,
	"./hn.svg": 4414,
	"./hr.svg": 3094,
	"./ht.svg": 1146,
	"./hu.svg": 8864,
	"./ic.svg": 6137,
	"./id.svg": 6319,
	"./ie.svg": 3770,
	"./il.svg": 8525,
	"./im.svg": 5384,
	"./in.svg": 1815,
	"./io.svg": 3878,
	"./ir.svg": 9192,
	"./is.svg": 6430,
	"./it.svg": 3914,
	"./je.svg": 7764,
	"./jm.svg": 2915,
	"./jo.svg": 1370,
	"./ke.svg": 6972,
	"./kg.svg": 1404,
	"./kh.svg": 4885,
	"./ki.svg": 3022,
	"./km.svg": 4533,
	"./kn.svg": 7341,
	"./kp.svg": 1384,
	"./kr.svg": 8467,
	"./kw.svg": 9466,
	"./ky.svg": 748,
	"./kz.svg": 63,
	"./la.svg": 5525,
	"./lb.svg": 2243,
	"./lc.svg": 6195,
	"./li.svg": 8150,
	"./lk.svg": 7365,
	"./lr.svg": 9882,
	"./ls.svg": 6190,
	"./lt.svg": 8358,
	"./lu.svg": 8127,
	"./lv.svg": 1634,
	"./ly.svg": 9271,
	"./ma.svg": 330,
	"./mc.svg": 6320,
	"./md.svg": 3651,
	"./me.svg": 7880,
	"./mf.svg": 3141,
	"./mg.svg": 2445,
	"./mh.svg": 3081,
	"./mk.svg": 2522,
	"./ml.svg": 8981,
	"./mm.svg": 6886,
	"./mn.svg": 1799,
	"./mo.svg": 6016,
	"./mp.svg": 3038,
	"./mq.svg": 328,
	"./mr.svg": 9296,
	"./ms.svg": 3731,
	"./mt.svg": 622,
	"./mu.svg": 173,
	"./mv.svg": 1218,
	"./mw.svg": 1566,
	"./mx.svg": 1744,
	"./mz.svg": 4939,
	"./na.svg": 3438,
	"./nc.svg": 2717,
	"./ne.svg": 1054,
	"./nf.svg": 2769,
	"./ng.svg": 5199,
	"./ni.svg": 3789,
	"./nl.svg": 4635,
	"./np.svg": 2944,
	"./nr.svg": 8915,
	"./nu.svg": 1276,
	"./nz.svg": 2903,
	"./pa.svg": 6316,
	"./pe.svg": 9684,
	"./pf.svg": 9300,
	"./pg.svg": 258,
	"./ph.svg": 4408,
	"./pk.svg": 1660,
	"./pl.svg": 1842,
	"./pm.svg": 6002,
	"./pn.svg": 2583,
	"./pr.svg": 4837,
	"./ps.svg": 1766,
	"./pt.svg": 313,
	"./pw.svg": 7825,
	"./py.svg": 9877,
	"./qa.svg": 3867,
	"./re.svg": 3774,
	"./ro.svg": 141,
	"./rs.svg": 772,
	"./ru.svg": 440,
	"./rw.svg": 7190,
	"./sa.svg": 3151,
	"./sb.svg": 8728,
	"./sc.svg": 9763,
	"./sd.svg": 9781,
	"./sg.svg": 4628,
	"./sh.svg": 6898,
	"./si.svg": 7713,
	"./sj.svg": 2983,
	"./sk.svg": 7997,
	"./sl.svg": 2600,
	"./sm.svg": 9419,
	"./sn.svg": 6949,
	"./so.svg": 1543,
	"./sr.svg": 6274,
	"./ss.svg": 3092,
	"./st.svg": 9018,
	"./sv.svg": 4830,
	"./sx.svg": 4228,
	"./sy.svg": 2930,
	"./sz.svg": 19,
	"./ta.svg": 8612,
	"./tc.svg": 1604,
	"./td.svg": 3126,
	"./tf.svg": 9112,
	"./tg.svg": 1806,
	"./th.svg": 7858,
	"./tj.svg": 4453,
	"./tk.svg": 8735,
	"./tl.svg": 5139,
	"./tm.svg": 9162,
	"./tn.svg": 894,
	"./to.svg": 1954,
	"./tt.svg": 6207,
	"./tv.svg": 4748,
	"./tw.svg": 1850,
	"./tz.svg": 8801,
	"./ua.svg": 818,
	"./ug.svg": 1999,
	"./um.svg": 8307,
	"./un.svg": 6608,
	"./uy.svg": 5400,
	"./uz.svg": 5588,
	"./va.svg": 7681,
	"./vc.svg": 6051,
	"./ve.svg": 3416,
	"./vg.svg": 4892,
	"./vi.svg": 4843,
	"./vn.svg": 7451,
	"./vu.svg": 9219,
	"./wf.svg": 1233,
	"./ws.svg": 7509,
	"./xk.svg": 5233,
	"./xx.svg": 766,
	"./ye.svg": 6163,
	"./yt.svg": 7298,
	"./za.svg": 6635,
	"./zm.svg": 1526,
	"./zw.svg": 8837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7746;